import PromoManagementPage from './PromoManagementPage';

export default PromoManagementPage;
